module.exports = __webpack_public_path__ + "static/img/DAFABET MOBILE  Promo Summary Thumbnail_0.80de6c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DAFABET MOBILE  Promo Summary Thumbnail_0.jpg
// module id = ccsz
// module chunks = 0